import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CardBody } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import 'assets/scss/components/surveyReport.css';
import { NPS_COLORS as COLORS } from 'constants/index';
import NPSCommentModal from './npsCommentModal';

const NPSAnswersList = ({ question }) => {
  const { nps, participants_count } = question;
  const backgroundColor = nps.score < 0 ? COLORS.DETRACTORS : COLORS.PROMOTERS;
  const formattedNPSScore = Math.floor(nps.score);

  return (
    <div className="survey-nps-report" key={question.question_id}>
      <div className="row">
        <div className="col-md-4 d-flex justify-content-center">
          <div className="score-display" style={{ backgroundColor }}>
            <div className="nps-score">{Math.abs(formattedNPSScore)}</div>
            <div className="text-center">NPS SCORE</div>
          </div>
        </div>
        <div className="col-md-8">
          <NPSAnswerList
            question={question.question}
            participants_count={participants_count}
            title="Promoters"
            customerType={nps.promoters}
            fillColor={COLORS.PROMOTERS}
          />
          <NPSAnswerList
            question={question.question}
            title="Passives"
            participants_count={participants_count}
            customerType={nps.passives}
            fillColor={COLORS.PASSIVES}
          />
          <NPSAnswerList
            question={question.question}
            title="Detractors"
            participants_count={participants_count}
            customerType={nps.detractors}
            fillColor={COLORS.DETRACTORS}
          />
        </div>
      </div>
    </div>
  );
};

const NPSAnswerList = ({
  fillColor,
  title,
  customerType,
  question,
  participants_count,
}) => {
  const [isModalOpen, setModalStatus] = useState(false);
  const { percentage, count, comments } = customerType;
  const ratio = parseInt(percentage || 0) / 100;
  const displayPercentage = `${percentage || 0}%`;
  const reportStatusFillStyle = {
    width: displayPercentage,
    borderBottomRightRadius: `${ratio === 1 ? '25px' : ''}`,
    borderTopRightRadius: `${ratio === 1 ? '25px' : ''}`,
    backgroundColor: fillColor,
  };

  return (
    <React.Fragment>
      <NPSCommentModal
        isOpen={isModalOpen}
        toggle={() => setModalStatus(!isModalOpen)}
        participants_count={participants_count}
        title={title}
        question={question}
        ratio={ratio}
        percentage={percentage}
        comments={comments}
        count={count}
      />
      <CardBody>
        <div className="row">
          <div className="col-md-7">
            <div className="report-status-bar">
              <div
                className="report-status-fill"
                style={reportStatusFillStyle}
              />
            </div>
            <div>{title}</div>
          </div>
          <div className="col-md-3">{displayPercentage}</div>
          <div className="col-md-1">{count}</div>
          {comments.length > 0 && (
            <div className="col-md-1">
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => setModalStatus(true)}
              >
                <FontAwesomeIcon className="fa-2x comment-box" icon="comment" />
                <span className="comments-count">{comments.length}</span>
              </div>
            </div>
          )}
        </div>
      </CardBody>
    </React.Fragment>
  );
};

NPSAnswerList.propTypes = {
  answer: PropTypes.shape({
    answer_count: PropTypes.number,
    id: PropTypes.string,
    comments_count: PropTypes.number,
    title: PropTypes.string,
  }),
  participants_count: PropTypes.number,
  dateRange: PropTypes.shape({
    startDate: PropTypes.any,
    endDate: PropTypes.any,
  }),
};

NPSAnswerList.defaultProps = {
  answer: {},
  participants_count: 0,
  dateRange: {},
};

export default NPSAnswersList;



// WEBPACK FOOTER //
// ./src/components/reports/nps/AnswersReport.js